import React from 'react';
import MetaData from './MetaData';
import { Link } from 'react-router-dom';

const UnderConstruction = () => (
  <>
    <MetaData title="Under Construction" />
    <div className="row wrapper" style={{ minHeight: '70vh' }}>
      <div className="col-10 col-lg-6 text-center">
        <div className="card p-5">
          <h1 className="display-4 fw-bold text-info mb-3">🚧 Coming Soon</h1>
          <p className="text-muted mb-4">We're working hard to bring you something amazing! Please check back soon.</p>
          <div className="mb-4">
            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
          <Link to="/" className="btn btn-primary py-2 px-4 fw-semibold">
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  </>
);

export default UnderConstruction;